import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import fr from './locales/fr.json';

// LanguageDetector automatically picks the browser's language on first load.
// If the driver's phone is set to French, the app opens in French automatically.
// Their choice (if they manually switch) gets saved and remembered on future visits.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
    fallbackLng: 'en', // if a translation key is missing in the detected language, fall back to English
    interpolation: {
      escapeValue: false, // React already escapes values, so we don't need i18next to do it too
    },
  });

export default i18n;